
import Page from '@root/common/base/Page';
import ListSkeletonLoader from '@root/common/components/base/loader/ListSkeletonLoader.vue';
import { QueryResult } from '@root/modules/headlines/types/headlines';
import MostReadArticlesService from '@root/modules/headlines/services/MostReadArticles.service';
import HeadlineList from '@root/common/components/base/headline/HeadlineList.vue';
import PageHeader from '@root/common/components/base/PageHeader.vue';

export default Page.extend({
  components: {
    HeadlineList,
    PageHeader,
    ListSkeletonLoader,
  },
  data() {
    return {
      popularHeadlines: {
        items: [],
        pager: {
          offset: 0,
          limit: 0,
        },
      } as QueryResult,
      headlineSettings: { lead: true, publishDate: false, author: false, titleComment: true },
    };
  },
  async fetch() {
    const limit = 100;
    const viewsSince = 'SINCE_24_HOURS';
    const { domain } = this.$channelConfig('settings');
    const variables: { limit: number; viewsSince: 'SINCE_24_HOURS'; domain: string | string[] } = { limit, viewsSince, domain };

    try {
      const mostReadArticlesService = new MostReadArticlesService({ req: this.$ssrContext?.req });
      this.popularHeadlines = await mostReadArticlesService.fetch(variables);
    } catch (e) {
      this.handlePageError(e);
    }
  },
  head() {
    const meta = this.getPageMeta();
    const title: string = this.$t('popular.title');
    meta.setTitle({ title });

    return {
      title: meta.title,
      meta: meta.data,
      link: meta.link,
    };
  },
  mounted() {
    this.restoreScroll();
  },
});
